import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-all-independence-declaration',
  templateUrl: './all-independence-declaration.component.html',
  styleUrls: ['./all-independence-declaration.component.css']
})
export class AllIndependenceDeclarationComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {
  }

  PostAssignClick(){
    this.router.navigate(['dashboard/annual-independence']);
  }

  clientDeclaClick(){
    this.router.navigate(['dashboard/client-independence']);
  }

  employeeJoinClick(){
    this.router.navigate(['dashboard/employee-independence']);
  }

  annualDeclaClick(){
    this.router.navigate(['dashboard/all-client-independence']);
  }

  dpdpDeclarationClick(){
    this.router.navigate(['dashboard/dpdp-declaration']);
  }

}
